import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Header from '../Header/Header';
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { useDrawerProvider } from '../../providers/DrawerContext';

const useStyles = makeStyles((theme) => ({
    appBar: {
        backgroundColor: '#ffffff',
        color: '#1a2e22',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        borderLeft: '1px solid rgba(0,0,0,0.05)',
        zIndex: theme.zIndex.drawer + 1,
        width: drawer => drawer.openDesktop
            ? `calc(100% - ${drawer.drawerWidth}px)`
            : `calc(100% - ${drawer.openDesktopWidth}px)`,
        transition: theme.transitions.create(['width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            borderLeft: 'none',
            position: 'static',
            boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        },
    },
    toolbar: {
        paddingLeft: 0,
        paddingRight: 0,
        minHeight: drawer => drawer.barHeight,
        [theme.breakpoints.down('sm')]: {
            paddingLeft: 0,
            paddingRight: 0,
        },
    },
}));

export default function HeaderBar() {

    const { state } = useDrawerProvider();
    const classes = useStyles(state);

    return (
        <AppBar
            position="absolute"
            className={classes.appBar}
            elevation={0}
        >
            <Toolbar className={classes.toolbar}>
                <Header />
            </Toolbar>
        </AppBar>
    );
}
